import styled from 'styled-components'

export const List = styled.ul`
  padding-bottom: 12px;
`

export const ListItem = styled.li`
  padding-bottom: 6px;
`
